import React from 'react';
import { Box, Typography } from '@material-ui/core';
import DateTimePicker from 'react-datetime-picker';
import './styles.css';

interface CustomDateSelectorProps {
  title?: string;
  value?: Date;
  onChange: (value: Date) => void;
  onReset: () => void;
  format?: string;
}

const CustomDateSelector = ({
  title,
  value,
  onChange,
  onReset,
  format,
}: CustomDateSelectorProps) => {
  return (
    <Box
      position={'relative'}
      display={'flex'}
      flexDirection={'row'}
      alignItems={'center'}
    >
      <Box display={'flex'} marginRight={'10px'}>
        <p className='base-color'>{title ? title : 'Select Date'}</p>
        <button
          className='clear-date-button'
          disabled={!value}
          onClick={onReset}
        >
          (x)
        </button>
      </Box>
      <Box
        position={'relative'}
        display={'flex'}
        alignItems={'center'}
        marginTop={'25px'}
      >
        <DateTimePicker
          value={value}
          format={format ? format : 'dd-MM-y'}
          onChange={onChange}
          maxDate={new Date('2051-01-18T19:55:00.000+00:00')}
          minDate={new Date('2000-01-18T19:55:00.000+00:00')}
          disableClock
        />
      </Box>
    </Box>
  );
};

export default CustomDateSelector;
